export const getContractAddress = (address) => address;
export const getUrl = (url) => url;
//# sourceMappingURL=utils.js.map